import { combineReducers, Reducer } from 'redux';

import { RestApiId } from '../restApis';
import { dataReducer, DataState } from './dataReducer';
import { Status, statusReducer } from './statusReducer';
import { updatesReducer, UpdatesState } from './updatesReducer';

export interface State<T> {
  data: DataState<T>;
  status: Status;
  updates: UpdatesState<T>;
}

export function reducer<T, S = RestApiId>(service: S): Reducer<State<T>> {
  return combineReducers<State<T>>({
    data: dataReducer<T, S>(service),
    status: statusReducer<T, S>(service),
    updates: updatesReducer<T, S>(service),
  });
}
